/**
 * Defines the width for the field. 
 * The exact width value for each size
 * should be defined through Css classes.
 */
export enum VariableFieldSize {
    NORMAL = 0,
    BIG = 1
}